var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "graphicnavigation",
      style: { backgroundImage: "url(" + _vm.datas.bgImg + ")" },
    },
    [
      !_vm.datas.imageList[0]
        ? _c(
            "section",
            {
              staticClass: "defaultNavigation",
              style: {
                background: _vm.datas.backgroundColor,
                display: _vm.datas.imgStyle === 0 ? "flex" : "-webkit-box",
                "flex-wrap": _vm.datas.imgStyle === 0 ? "wrap" : "nowrap",
                "justify-content":
                  _vm.datas.positions === "center" ? "center" : "flex-start",
                "overflow-x": _vm.datas.imgStyle === 0 ? "" : "scroll",
              },
            },
            _vm._l(5, function (index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "navigationList",
                  style: {
                    width:
                      _vm.datas.imgStyle === 0
                        ? "20%"
                        : 375 / _vm.datas.showSize - 1 + "px",
                  },
                },
                [
                  _c("p", { style: { color: _vm.datas.textColor } }, [
                    _vm._v("导航"),
                  ]),
                ]
              )
            }),
            0
          )
        : _c(
            "section",
            {
              staticClass: "defaultNavigation",
              style: {
                background: _vm.datas.backgroundColor,
                display: _vm.datas.imgStyle === 0 ? "flex" : "-webkit-box",
                "flex-wrap": _vm.datas.imgStyle === 0 ? "wrap" : "nowrap",
                "justify-content":
                  _vm.datas.positions === "center" ? "center" : "flex-start",
                "overflow-x": _vm.datas.imgStyle === 0 ? "" : "scroll",
              },
            },
            _vm._l(_vm.datas.imageList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "navigationList",
                  style: {
                    width:
                      _vm.datas.imgStyle === 0
                        ? "20%"
                        : 375 / _vm.datas.showSize - 1 + "px",
                    "border-bottom": _vm.datas.underline
                      ? "1px solid #000000"
                      : "none",
                  },
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.datas.navigationType === 2 ||
                          _vm.datas.navigationType === 0,
                        expression:
                          "datas.navigationType === 2 || datas.navigationType === 0",
                      },
                    ],
                    style: { "border-radius": _vm.datas.borderRadius + "%" },
                    attrs: {
                      src: _vm.resPath + item.src,
                      alt: "",
                      draggable: "false",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.datas.navigationType === 1 ||
                            _vm.datas.navigationType === 0,
                          expression:
                            "datas.navigationType === 1 || datas.navigationType === 0",
                        },
                      ],
                      style: {
                        color: _vm.datas.textColor,
                        "font-size": _vm.datas.textSize + "px",
                        height: _vm.datas.textHeight + "px",
                        "line-height": _vm.datas.textHeight + "px",
                      },
                    },
                    [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]
                  ),
                ]
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }